export type BackgroundFrame = { x: number; y: number; zoom: number };
export const backgroundPercent = (value: number) => Math.max(0, Math.min(100, value));

/** Cover crop plus zoom, with no exposed edges, for stills and motion alike. */
export function panRecordingBackground(start: BackgroundFrame, delta: { x: number; y: number },
  frame: { width: number; height: number }, image: { width: number; height: number }): BackgroundFrame {
  if (frame.width <= 0 || frame.height <= 0 || image.width <= 0 || image.height <= 0) return start;
  const cover = Math.max(frame.width / image.width, frame.height / image.height) * start.zoom / 100;
  const overflowX = image.width * cover - frame.width, overflowY = image.height * cover - frame.height;
  return { ...start,
    x: overflowX > .01 ? backgroundPercent(start.x - delta.x / overflowX * 100) : start.x,
    y: overflowY > .01 ? backgroundPercent(start.y - delta.y / overflowY * 100) : start.y };
}
